module.exports = "<style>body .breadcrumb a,body .breadcrumb span{font-size:13px}</style>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/customStyle.html
// module id = 684
// module chunks = 0